// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6061baa3","152":"bdd091cb","166":"52311f45","182":"6248234f","241":"d094b863","309":"7a6c322c","370":"33e41a9e","418":"c42e9711","982":"4182518c","989":"3ee93ac5"}[chunkId] + ".chunk.js";
};